import React, { Fragment } from 'react';
import Validationtip from '../validationtip/Validationtip';

interface GridCellWrapperProps {
  label?: any;
  classes?: string;
  children: any;
  withLabel?: boolean;
  name?: string;
}

const GridCellWrapper = ({
  label,
  classes,
  children,
  withLabel = true,
  name,
}: GridCellWrapperProps) => {
  return (
    <div className={'grid-cell-wrapper ' + classes}>
      {withLabel && (
        <Fragment>
          <div className='card-header noSelect'>
            <div className={'label-content'}>
              {' '}
              <Validationtip fieldName={name ?? ''}>{label} </Validationtip>
            </div>

            <div className='color-corner' />
          </div>
        </Fragment>
      )}
      <div className='grid-cell-content'>{children}</div>
    </div>
  );
};
export default GridCellWrapper;
